import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

// Real admin check: look up this user's own users/{uid} Firestore doc and
// require isAdmin === true. This mirrors firestore.rules' isAdmin() function,
// which is the actual security boundary for admin-only reads/writes -
// isAdmin is granted out-of-band (backend Admin SDK / console), never
// self-service. Any page gating a genuine admin-only read/write should use
// this rather than a hardcoded email, so it stays in sync with who can
// actually perform the action.
export default function useIsAdmin(user) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminChecked, setAdminChecked] = useState(false);

  useEffect(() => {
    if (!user) {
      setIsAdmin(false);
      setAdminChecked(true);
      return;
    }
    setAdminChecked(false);
    getDoc(doc(db, "users", user.uid))
      .then((userDoc) => {
        setIsAdmin(!!(userDoc.exists() && userDoc.data().isAdmin === true));
      })
      .catch((err) => {
        console.error("Error checking admin status:", err);
        setIsAdmin(false);
      })
      .finally(() => setAdminChecked(true));
  }, [user]);

  return { isAdmin, adminChecked };
}
